<template>
  <Modal
    id="policy-installment-history-modal"
    :title="`Histórico de alterações da parcela ${installmentNumber}`"
    :active.sync="active"
    @close="close"
  >
    <div class="mt-4">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th style="width: 18%">Data e Hora</th>
            <th style="width: 20%">Usuário</th>
            <th style="width: 18%">Campo</th>
            <th style="width: 22%">Valor Anterior</th>
            <th style="width: 22%">Novo Valor</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!history.length">
            <td colspan="5" class="text-center">
              Nenhum histórico encontrado.
            </td>
          </tr>
          <tr v-for="(item, index) in history" :key="index">
            <td>{{ formatDatetimeWithMoment(item.createdAt) }}</td>
            <td>
              {{ item.user && item.user.name ? item.user.name : 'System' }}
            </td>
            <td>{{ translateFieldName(item.fieldName) }}</td>
            <td>{{ formatValue(item.oldValue) }}</td>
            <td>{{ formatValue(item.newValue) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </Modal>
</template>

<script>
import moment from 'moment/moment';
import Modal from '../../components/Modal.vue';

const FIELD_NAME_TRANSLATIONS = Object.freeze({
  installment_value: 'Valor da parcela',
  installment_number: 'Número da parcela',
  iof: 'IOF',
  net_prize: 'Prêmio líquido',
  interest: 'Juros',
  payment_date: 'Data de pagamento',
  clearance_date: 'Data da baixa',
  credit_date: 'Data de crédito',
  payment_value: 'Valor do pagamento',
  meta: 'Metadados',
  payment_id: 'ID do pagamento',
  payment_type: 'Tipo de pagamento',
  status: 'Status',
  original_installment_value: 'Valor original da parcela',
});

const STATUS_TRANSLATIONS = Object.freeze({
  pending: 'Pendente',
  canceled: 'Cancelado',
  paid: 'Pago',
  underpaid: 'Pago com pendência',
});

export default {
  name: 'ModalPolicyInstallmentHistory',
  components: {
    Modal,
  },
  props: {
    activeProp: {
      type: Boolean,
      default: false,
    },
    historyProp: {
      type: Array,
      default: () => [],
    },
    installmentNumber: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      active: false,
      history: [],
      fieldNameTranslations: FIELD_NAME_TRANSLATIONS,
      statusTranslations: STATUS_TRANSLATIONS,
    };
  },
  watch: {
    activeProp() {
      this.active = this.activeProp;
    },
    historyProp: {
      handler(newValue) {
        this.history = newValue || [];
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    close() {
      this.active = false;
      this.$emit('close');
    },
    formatDatetimeWithMoment(date) {
      if (!date) return '-';
      return moment(date).format('DD/MM/YYYY HH:mm:ss');
    },
    translateFieldName(fieldName) {
      if (!fieldName) return '-';
      return this.fieldNameTranslations[fieldName] || fieldName;
    },
    formatValue(value) {
      if (value === null || value === undefined || value === '') {
        return '-';
      }
      if (typeof value === 'object') {
        return JSON.stringify(value);
      }
      if (this.statusTranslations[value]) {
        return this.statusTranslations[value];
      }
      return value;
    },
  },
};
</script>

<style scoped lang="scss">
.table-bordered {
  font-size: 1rem;
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  width: 100%;

  tr td {
    padding: 2px 2px 2px 10px;
  }

  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>

<style>
#policy-installment-history-modal.con-vs-popup .vs-popup {
  width: fit-content !important;
  min-width: 70% !important;
}
</style>
